import React, { Component, useEffect, useState } from "react"
import { Card, Col, Row } from "reactstrap"
import newIcon from "../../assets/images/new_icon.gif"
import { Link, withRouter } from "react-router-dom"
import PropTypes from "prop-types"
//i18n
import { withTranslation } from "react-i18next"
import demo from "../../assets/videos/demoEtud.mp4"
import API from "../../apis"
import {
  FaCog,
  FaEye,
  FaClipboardList,
  FaCheck,
  FaTimes,
  FaFilePdf,
} from "react-icons/fa"
import FileDownload from "js-file-download"
const tiles = [
  {
    title: "Avis d'orientation",
    icon: <FaClipboardList />,
    iconCheck: <FaCheck />,
    color: "#0E918C",
    download: "telecharger",
    name: "Télécharger",
    iconCheck2: <FaFilePdf />,
  },
  {
    title: "Edura Bureau d'ordre",
    icon: <FaCog />,
    iconCheck: <FaTimes />,
    color: "#F4C581",
    download: "url",
    name: "voir plus",
    iconCheck2: <FaEye />,
  },
]
var userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant"))
var annee_id = userAuthEtudiant.user.annee_id
var etat_orientation = userAuthEtudiant.user.etat_orientation
class NewsGrid extends Component {
  state = {
    etat: null,
    tiles: [], // important : initialiser tiles à un tableau vide
  }
  // componentDidMount() {
  //   API.post("orientation_config/check_ouverture", {
  //     annee_id: annee_id,
  //   }).then(resEtat => {
  //     this.setState({ etat: resEtat.data.Orientation })
  //   })
  //   API.post("orientation/avis/list", {
  //     annee_id: annee_id,
  //   }).then(res => {
  //     const apiTiles = res.data.avis.map(item => ({
  //       title: item.titre,
  //       icon: <FaFilePdf />, // tu peux changer en fonction du type
  //       iconCheck: <FaCheck />, // ou item.status si tu as une info
  //       color: "#0E918C", // ou calculé dynamiquement
  //       download: "telecharger", // ou item.downloadType
  //       name: "Télécharger",
  //       iconCheck2: <FaFilePdf />,
  //       id: item.id, // utile pour le download
  //     }))
  //     // On combine tiles statiques et tiles API
  //     setTiles([...staticTiles, ...apiTiles])
  //   })
  // }

  componentDidMount() {
    // Vérifier ouverture
    API.post("orientation_config/check_ouverture", { annee_id }).then(
      resEtat => {
        this.setState({ etat: resEtat.data.Orientation })
      }
    )

    // Récupérer la liste des avis
    API.post("orientation/avis/list", { annee_id }).then(res => {
      const staticTiles = [
        {
          title: "Orientation",
          icon: <FaClipboardList />,
          iconCheck: <FaTimes />,
          color: "#F4C581",
          download: "url",
          name: "voir plus",
          iconCheck2: <FaEye />,
        },
      ]

      const apiTiles =
        res.data.avis?.map(item => ({
          title: item.titre,
          icon: <FaFilePdf />,
          iconCheck: <FaCheck />,
          color: "#0E918C",
          download: "telecharger",
          name: "Télécharger",
          iconCheck2: <FaFilePdf />,
          id: item.id,
        })) || [] // <-- fallback si res.data.avis est undefined

      this.setState({ tiles: [...staticTiles, ...apiTiles] })
    })
  }
  constructor(props) {
    super(props)
    this.state = {
      nouveautes: [
        {
          id: 1,
          title: "Avis d'orientation",
          link: "#",
          date: "04/03/2022",
          image:
            "https://www.wikihow.com/images_en/thumb/2/26/Do-Homework-Step-6-Version-3.jpg/v4-460px-Do-Homework-Step-6-Version-3.jpg.webp",
          description: "Emploi du temps de l'enseignant",
        },
        {
          id: 2,
          title: "L'emploi des examens",
          link: "/CalendrierExam",
          date: "05/03/2022",
          image:
            "https://www.wikihow.com/images_en/thumb/2/26/Do-Homework-Step-6-Version-3.jpg/v4-460px-Do-Homework-Step-6-Version-3.jpg.webp",
          description: "Emploi des examens de l'enseignant",
        },
      ],
    }
  }
  downloadFile = async (id, titre) => {
    try {
      const res = await API.post(
        "orientation/avis/download",
        { id, annee_id: annee_id },
        { responseType: "blob" }
      )
      FileDownload(res.data, `${titre}.pdf`)
    } catch (error) {
      console.error(error)
    }
  }
  toggleDetail = (type = null,id=null,name=null) => {
    if (type === "url") {
      // redirection
      this.props.history.push("/Orientation")
    } else {
      // téléchargement fichier
      this.downloadFile(id,name)
    }
  }
  render() {
    const tiles = this.state.tiles || []
    return (
      <React.Fragment>
        <Col>
          <Card>
            <div>
              <Row className="justify-content-center">
                <Col xl={10}>
                  <div>
                    <Row>
                      <div className="mt-4">
                        <div>
                          <h2
                            style={{ color: "#556ee6", textAlign: "center" }}
                            className="mb-0"
                          >
                            {/* {this.props.t("À LA UNE")} */}
                            {this.props.t("Bienvenue dans l'espace Etudiant")}
                          </h2>
                        </div>
                      </div>
                      <div className="mt-4">
                        <div>
                          <h5 style={{}} className="">
                            {/* {this.props.t("À LA UNE")} */}
                            {this.props.t(
                              "vous êtes invités à consulter ce guide d'utilisation"
                            )}
                          </h5>
                        </div>
                      </div>
                    </Row>
                    {this.state.etat === 1 && etat_orientation === 1 ? (
                      <Row>
                        <div
                          style={{
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns:
                              "repeat(auto-fill, minmax(200px, 1fr))",
                            gap: "25px",
                            padding: "10px",
                          }}
                        >
                          {tiles.map((tile, index) => (
                            <div
                              key={index}
                              style={{
                                backgroundColor: tile.color,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                borderRadius: "10px",
                                cursor: "pointer",
                                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                transition: "transform 0.3s, box-shadow 0.3s",
                                color: "#fff",
                              }}
                              onMouseEnter={e => {
                                e.currentTarget.style.transform = "scale(1.05)"
                                e.currentTarget.style.boxShadow =
                                  "0 10px 20px rgba(0,0,0,0.3)"
                              }}
                              onMouseLeave={e => {
                                e.currentTarget.style.transform = "scale(1)"
                                e.currentTarget.style.boxShadow =
                                  "0 4px 8px rgba(0,0,0,0.2)"
                              }}
                            >
                              <div
                                style={{
                                  padding: "15px",
                                  textAlign: "center",
                                  flexGrow: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: "#fff",
                                    borderRadius: "50%",
                                    width: "70px",
                                    height: "70px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "0 auto 15px auto",
                                  }}
                                >
                                  {React.cloneElement(tile.icon, {
                                    size: 35,
                                    color: tile.color,
                                  })}
                                </div>
                                <div
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {tile.title}
                                </div>
                              </div>

                              {/* Actions */}
                              <div
                                style={{
                                  backgroundColor: "#fff",
                                  padding: "8px",
                                  display: "flex",
                                  justifyContent: "space-around",
                                  alignItems: "center",
                                  borderTop: `2px solid ${tile.color}`,
                                }}
                              >
                                <a
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "5px 10px",
                                    border: `1px solid ${tile.color}`,
                                    borderRadius: "5px",
                                    color: tile.color,
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                    gap: "11px",
                                    transition: "0.3s",
                                  }}
                                  onMouseEnter={e => {
                                    e.currentTarget.style.backgroundColor =
                                      tile.color
                                    e.currentTarget.style.color = "#fff"
                                  }}
                                  onMouseLeave={e => {
                                    e.currentTarget.style.backgroundColor =
                                      "#fff"
                                    e.currentTarget.style.color = tile.color
                                  }}
                                  onClick={() =>
                                    this.toggleDetail(
                                      tile.download,
                                      tile.id,
                                      tile.title
                                    )
                                  }
                                >
                                  {tile.iconCheck2 &&
                                    React.cloneElement(tile.iconCheck2, {
                                      style: {
                                        fontSize: "20px",
                                        color: "inherit",
                                      },
                                    })}
                                  {tile.name}
                                </a>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Row>
                    ) : null}

                    <Row className="align-items-center">
                      <div className="mt-4">
                        <div>
                          <video
                            src={demo}
                            width="100%"
                            controls="controls"
                            autoPlay="true"
                          />
                        </div>
                      </div>
                    </Row>
                    {/* <hr className="mb-4" /> */}
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
        </Col>
      </React.Fragment>
    )
  }
}


NewsGrid.propTypes = {
  t: PropTypes.any,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
}
export default withRouter(withTranslation()(NewsGrid))
